import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import Spinner from "../../components/shared/spinner/Spinner";
import { RootState } from "../../redux/store";
import $axios from "../../api/accessor";

interface PrivacyData {
  title?: string;
  content?: string;
}

const Privacy = () => {
  const [privacyData, setPrivacyData] = useState<PrivacyData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const language = useSelector((state: RootState) => state.language.language);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    $axios.get('/privacy-policy')
      .then((res) => setPrivacyData(res?.data))
      .finally(() => setLoading(false));
  }, [language]);

  return (
    <div id="this_page">
      <TitleUpdater 
        title="Colibri | Gizlilik şərtləri"
      />
      <div className="container">
        {loading ? (
          <Spinner />
        ) : (
          <div className="privacy">
            <h1 className="page_title">
              {data?.privacy_policy || "Gİzlİlİk şərtlərİ"}
            </h1>
            <div className="this_page">
              {privacyData?.content && (
                <div 
                  className="page_content"
                  dangerouslySetInnerHTML={{ __html: privacyData.content }}
                />
              )}
            </div>
            <MobileAppSection />
          </div>
        )}
      </div>
    </div>
  );
};

export default Privacy;